// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"523":"7f77d1a9","658":"b5d78fd8","751":"a1a8fa85","874":"0d158c44"}[chunkId] + ".chunk.js";
};